import { render, staticRenderFns } from "./searchChetouIndex.vue?vue&type=template&id=4bbdaedf&scoped=true&"
import script from "./searchChetouIndex.vue?vue&type=script&lang=js&"
export * from "./searchChetouIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbdaedf",
  null
  
)

export default component.exports